<template>
<div style="position:relative; min-height:100vh;overflow-x:hidden">
    <Sidebar v-if="appart"/>
    <Sidebar v-else title="Logis du Chateau" link="https://www.airbnb.fr/rooms/36438518" appartement="/logisduchateau"/>
    <div id="map" class="mapio"></div>
    <div class="container-r">
        <div class="title">Les Randonnées de l'Eure</div>

    <randonneeList ref="randonneelist">

    </randonneeList>
        

    

    </div>
</div>
    
</template>

<script>
import Card from '../components/Card'
import Sidebar from '../components/Sidebar'
import {randonneeItem, randonneeList} from '../components/CardRandonnee.vue'
import Vue from 'vue'
export default {
    name : 'Gaillon',
    components : {
        Sidebar,
        randonneeList
      
        
     
    },computed: {

        appart() {
            if(this.$route.params.appartement == "chateau") return false;
            return true
        },
        

    },
    methods : {


        InitCardAndMap :async function()
        {
            const store = this.$firestore;
            const storage = this.$storage;
            const context = this;
            let docs = await store.collection('randonnées').get()
            return new Promise((resolve, reject) => {

            var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
            mapboxgl.accessToken = 'pk.eyJ1IjoiYW50b2luZTI3OTQwIiwiYSI6ImNrYzU0ZDRwejBlMm8ydXJpMWc5Yzl4eG4ifQ.qxFud6gO7OhHs4ampjyOTg';
            var map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/outdoors-v11',
            center : [1.334275,49.160468],
            zoom : 12,
            });

            const mapLoaded = function()
            {
                resolve([map, context]);
            }

            map.on('load',mapLoaded )

                
            }).then((array) => {
                const map = array[0];
                const context= array[1];
                return new Promise((resolve, reject) => {
                    let i = 0;
                    let instances = []
                const xhrLoad = function(doc, xhr)
                {
                    i+=1;
                    const geojson1 = JSON.parse(xhr.responseText);
                 
                    
                    var ItemClass = Vue.extend(randonneeItem);
                    var instance = new ItemClass({
                    propsData : {
                            title: doc.data().title,
                            content: doc.data().content,
                            visorando_url : doc.data().visorando_url,
                            geojson : geojson1,
                            difficulty : doc.data().difficulty,
                            distance : doc.data().distance,
                            denivele : doc.data().denivele,
                            }
                        });
                    instance.$mount();
                    instances.push(instance);
                    context.$refs.randonneelist.$el.appendChild(instance.$el)
                    if(i == docs.docs.length)

                    {
                        resolve([map,instances]);
                    }

                }
                docs.forEach(function(doc){
                    const xhr = new XMLHttpRequest();
                    xhr.onload = xhrLoad.bind(event, doc, xhr);
                    xhr.open('GET', doc.data().geojson);
                    xhr.send(null);
                    

                })
                })
            })
        },
        LaunchPromise : async function ()
        {
           const array =  await this.InitCardAndMap();
        
           this.$refs.randonneelist.inita(array[0], array[1])
           
        }



     
        

       


        

        
        
    },




    created() {
       


    
    },

    mounted() {

        //initialisation de la map
        //map.on('load', this.$refs.randonneelist.init.bind(event, map))
        this.LaunchPromise();
        




    }
}
</script>

<style scoped>

.container-r {
    
     pointer-events:none;

}

.mapio {
    position: absolute;
    top: 0;
    padding-bottom: 1rem;
    width: 100vw;
    height: 100%;
    z-index: 0;
    overflow: hidden;
}
.mapboxgl-canvas {
    height: 100%;
  }


</style>